import React from 'react';

const About = () => {
    return (
        <div className='container vh-100'>
            <div className="text-center my-5">
                <h3>About Me</h3>
                <h2>Hi! I am <br /> <span className='text-danger'>Khan Mohammad Imran</span> </h2>
                <p>I want to be a Web Developer. I am very interested in creating websites and learning programming languages. This is probably the only thing that I don't get bored with. My goal is to become more proficient in JavaScript and react. I want to be a full stack developer in the next 5 months. I am also learning the backend so that I can be a self-sufficient developer. That's why I'm working hard and I will until I reach my goal. I wanted to do a remote web developer job. I will be able to experience more new things. I can do real-time projects. Which will help me to make a better developer. Also a huge thanks to Programming Hero Team. They are helping me a lot in fulfilling my dream of becoming a developer. May Allah bless them. Please keep me in your prayer so that I can reach my goal.</p>
            </div>
        </div>
    );
};

export default About;